<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Contribution or Deductions"
      text="Update contribution or deduction"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localContributionDeduction.name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-8"
            >
              <tiptap-vuetify
                v-model="localContributionDeduction.description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localContributionDeduction.type" 
                v-validate="'required'"
                :error-messages="errors.collect('type')"    
                data-vv-name="type" 
                data-vv-as="type"
                label="Type"
                item-text="name"
                item-value="id"
                :items="types"
                outlined
              />
            </v-col>

            <v-col
              v-if="localContributionDeduction.type === 'tax'"
              cols="12"
              class="py-0"
            >
              <span>Deduct Epf? </span>
              <v-radio-group
                v-model="localContributionDeduction.is_deduct_epf"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
        
            <v-col
              v-if="localContributionDeduction.type === 'rbf'"
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="localContributionDeduction.retirement_age"
                label="Retirement Age"
                type="number"
              />
            </v-col>
            
            <v-col
              v-if="localContributionDeduction.type === 'epf'"
              cols="12"
              class="py-0"
            >
              <v-row>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="localContributionDeduction.employee_epf_default_rate"
                    v-validate="localContributionDeduction.employee_epf_default_amount ? '':'required|oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employee_epf_default_rate')"  
                    data-vv-name="employee_epf_default_rate"
                    data-vv-as="employee EPF rate"
                    label="Employee EPF Rate Exceed Table Limit"
                    type="number"
                    suffix="%"
                    clearable
                    outlined
                    :disabled="localContributionDeduction.employee_epf_default_amount ? true : false"
                    :filled="localContributionDeduction.employee_epf_default_amount ? true : false"
                    @change="localContributionDeduction.employee_epf_default_amount = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="localContributionDeduction.employee_epf_default_amount"
                    v-validate="(localContributionDeduction.employee_epf_default_rate || localContributionDeduction.employee_epf_default_rate === 0) ? '':'required|twoDecimalValue'"
                    label="Employee EPF Amount"
                    :error-messages="errors.collect('employee_epf_default_amount')"  
                    data-vv-name="employee_epf_default_amount"
                    data-vv-as="employee EPF amount"
                    type="number"
                    prefix="RM"
                    clearable
                    :disabled="localContributionDeduction.employee_epf_default_rate || localContributionDeduction.employee_epf_default_rate == 0 ? true:false"
                    :filled="localContributionDeduction.employee_epf_default_rate || localContributionDeduction.employee_epf_default_rate == 0 ? true:false"
                    @change="localContributionDeduction.employee_epf_default_rate = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="localContributionDeduction.employer_epf_default_rate"
                    v-validate="localContributionDeduction.employer_epf_default_amount ? '':'required|oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employer_epf_default_rate')"  
                    data-vv-name="employer_epf_default_rate"
                    data-vv-as="employer EPF rate"
                    label="Employer EPF Rate Exceed Table Limit"
                    type="number"
                    suffix="%"
                    clearable
                    outlined
                    :disabled="localContributionDeduction.employer_epf_default_amount ? true:false"
                    :filled="localContributionDeduction.employer_epf_default_amount ? true:false"
                    @change="localContributionDeduction.employer_epf_default_amount = null"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="py-0"
                >
                  <v-text-field
                    v-model="localContributionDeduction.employer_epf_default_amount"
                    v-validate="localContributionDeduction.employer_epf_default_rate ? '':'required|twoDecimalValue'"
                    :error-messages="errors.collect('employer_epf_default_amount')"  
                    data-vv-name="employer_epf_default_amount"
                    data-vv-as="employer EPF amount"
                    label="Employer EPF Amount"
                    type="number"
                    prefix="RM"
                    clearable
                    :disabled="localContributionDeduction.employer_epf_default_rate || localContributionDeduction.employer_epf_special_case_rate ? true : false"
                    :filled="localContributionDeduction.employer_epf_default_rate || localContributionDeduction.employer_epf_special_case_rate ? true : false"
                    @change="localContributionDeduction.employer_epf_default_rate = null; localContributionDeduction.employer_epf_special_case_rate = null"
                  />
                </v-col>
                <v-col
                  class="py-0"
                >
                  <v-text-field
                    v-model="localContributionDeduction.employer_epf_special_case_rate"
                    v-validate="localContributionDeduction.employer_epf_default_amount ? '' : 'oneDecimalValue|pointFive'"
                    :error-messages="errors.collect('employer_epf_special_case_rate')"  
                    data-vv-name="employer_epf_special_case_rate"
                    data-vv-as="employer EPF rate for special case"
                    label="Employer EPF Rate when wages received are RM5000 and below and upon sum with bonus exceed RM5000"
                    type="number"
                    suffix="%"
                    clearable
                    outlined
                    :disabled="localContributionDeduction.employer_epf_default_amount ? true : false"
                    :filled="localContributionDeduction.employer_epf_default_amount ? true : false"
                    @change="localContributionDeduction.employer_epf_default_amount = null"
                  />
                </v-col>
              </v-row> 
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    props: {
      contributionDeduction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localContributionDeduction: null,
        loading: false,
        types: [
          // { id: 'baitulmal', name: 'BAITULMAL' },
          { id: 'eis', name: 'EIS' },
          { id: 'epf', name: 'EPF' },
          // { id: 'grt', name: 'GRT' },
          // { id: 'hrd', name: 'HRD' },
          // { id: 'rbf', name: 'RBF' },
          { id: 'socso', name: 'SOCSO' },
          { id: 'tax', name: 'TAX' },
          // { id: 'zakat', name: 'ZAKAT' },
        ],
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localContributionDeduction = { ...this.contributionDeduction }

        if (this.localContributionDeduction.employee_epf_default_rate) { this.localContributionDeduction.employee_epf_default_rate = this.localContributionDeduction.employee_epf_default_rate / 100 }
        if (this.localContributionDeduction.employee_epf_default_amount) { this.localContributionDeduction.employee_epf_default_amount = this.localContributionDeduction.employee_epf_default_amount / 100 }
        if (this.localContributionDeduction.employer_epf_default_rate) { this.localContributionDeduction.employer_epf_default_rate = this.localContributionDeduction.employer_epf_default_rate / 100 }
        if (this.localContributionDeduction.employer_epf_special_case_rate) { this.localContributionDeduction.employer_epf_special_case_rate = this.localContributionDeduction.employer_epf_special_case_rate / 100 }
        if (this.localContributionDeduction.employer_epf_default_amount) { this.localContributionDeduction.employer_epf_default_amount = this.localContributionDeduction.employer_epf_default_amount / 100 }

        let _this = this
        this.$validator.extend('twoDecimalValue', {
          getMessage (field, args) {
            return 'Only 2 Decimals are allowed'
          },
          validate (value, args) {
            return _this.isValidNumbers(value)
          },
        })

        this.$validator.extend('oneDecimalValue', {
          getMessage (field, args) {
            return 'Only 1 Decimals are allowed'
          },
          validate (value, args) {
            return (new Big(value).times(1000) % 100 === 0)
          },
        })

        this.$validator.extend('pointFive', {
          getMessage (field, args) {
            return 'Only 0.5 is allowed'
          },
          validate (value, args) {
            if (value.toString().indexOf('.') > -1) {
              let arr = [...value.split('.')[1]]
              return arr[0] === '5' || arr[0] === '0'
            } else {
              return true
            }
          },
        })

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.contributionDeductions().update(this.contributionDeduction.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localContributionDeduction.name,
          description: this.localContributionDeduction.description,
          type: this.localContributionDeduction.type,
          is_deduct_epf: this.localContributionDeduction.is_deduct_epf,
          retirement_age: this.localContributionDeduction.retirement_age,      
          employee_epf_default_rate: this.localContributionDeduction.employee_epf_default_rate,
          employee_epf_default_amount: this.localContributionDeduction.employee_epf_default_amount,
          employer_epf_default_rate: this.localContributionDeduction.employer_epf_default_rate,
          employer_epf_special_case_rate: this.localContributionDeduction.employer_epf_special_case_rate,
          employer_epf_default_amount: this.localContributionDeduction.employer_epf_default_amount,
        }
      },
      
      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
